import React from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';

const HeaderStyled = styled.header`
  height: 100px;
  padding: 10px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${(props) => props.theme.headerColor};
`;

const Img = styled.img`
  height: 100%;
`;

export const Header = () => {
  const theme = useTheme();
  return (
    <HeaderStyled>
      <Img src={theme.logo} />
    </HeaderStyled>
  );
};
